<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "UserInviteTask",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'phone',
        placeholder: '用户名',
        type: 'input'
      },],
      permission: {
        add: 'userInviteTask:add',
        update: 'userInviteTask:update',
        delete: 'userInviteTask:delete',
        deleteBatch: 'userInviteTask:deleteBatch'
      },
      url: {
        get: '/userInviteTask/listByCondition',
        add: '/userInviteTask/add',
        update: '/userInviteTask/update',
        delete: '/userInviteTask/delete/',
        delete_batch: '/userInviteTask/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, {
        field: 'inviteNumber',
        label: '邀请人数',
        show: true,
        width: '',
      }, {
        field: 'remainingNumber',
        label: '剩余人数',
        show: true,
        width: '',
      }, {
        field: 'firstChargeMoney',
        label: '首充金额',
        show: true,
        width: '',
      }, {
        field: 'status',
        label: '状态',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '未完成',
            type: 'info'
          }, {
            key: 1,
            value: '已完成',
            type: 'success'
          }]
        },
        detail: false,
        width: '',

      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '会员邀请',
        updateTitle: '会员邀请',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'userId',
          label: '用户ID',
          type: 'textarea',
          placeholder: '用户ID',
          rules: [{message: '请输入用户ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'inviteNumber',
          label: '邀请人数',
          type: 'textarea',
          placeholder: '邀请人数',
          rules: [{message: '请输入上级ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'remainingNumber',
          label: '剩余人数',
          type: 'textarea',
          placeholder: '剩余人数',
          rules: [{message: '请输入剩余人数', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'firstChargeMoney',
          label: '首充金额',
          type: 'textarea',
          placeholder: '首充金额',
          rules: [{message: '请输入首充金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
